// src/hooks/useScriptReloader.js
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

export default function useScriptReloader() {
  const { pathname } = useLocation();

  useEffect(() => {
    // This will reload main.js every time the route changes
    const script = document.createElement("script");
    script.src = "/assets/js/main.js?v=1.0.1";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [pathname]);
}
